module.exports = {
  "id": "ff677621-63c2-465f-af82-e5ec7fe74a46",
  "gtmIds": [
    "GTM-5F9DZ99B",
    "GTM-W2KC5KLQ"
  ],
  "startTracking": "since_launch",
  "hasInAppVersion": false,
  "group": "Snowriver",
  "language": "en-US",
  "defaultDateFormat": {
    "id": 2,
    "format": "MM/DD/YYYY",
    "name": "Numeric Month First (04/23/2026)"
  },
  "defaultNumberFormat": {
    "id": 1,
    "name": "English (Comma thousands, Dot decimals)",
    "format": "#,###.##"
  },
  "pricingSavingsAmountPrecision": "exact",
  "checkoutTaxesFeesBreakdownDisplayMode": "modal",
  "languages": [
    "en-US"
  ],
  "website": "https://book.snowriver.com",
  "imageDeliveryUrl": "public-assets.spotliodata.com"
}